import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import checkResponse from '@/utils/checkResponse'
import Crud from '../crud'
Vue.use(Vuex)

const state = {
  catalog: {},
  orders: [],
  warehousesOptions: []
}

const mutations = {
  SET_ORDERS (state, payload) {
    state.orders = payload.data
  },
  SET_WAREHOUSES_OPTIONS (state, payload) {
    state.warehousesOptions = payload
  }
}

const actions = {
  async loadDefaultOrders ({ commit }) {
    try {
      const response = await axios.get(`orders/planner-default`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'alert-circle-outline' }, { root: true })
      } else {
        commit('SET_ORDERS', response.data)
        const warehouses = response.data.data.flatMap(order => order.warehouse_names)
        const uniqueWarehouses = [...new Set(warehouses)]
        commit('SET_WAREHOUSES_OPTIONS', uniqueWarehouses)
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'alert-circle-outline' }, { root: true })
    }
  },
  async loadOrders ({ commit }) {
    try {
      const checkSyncro = await axios.get(`contpaq/syncro`)
      const checkErrors = checkResponse(checkSyncro)
      if (checkErrors) {
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.contpaq', title: 'errors.syncro', icon: 'alert-circle-outline' }, { root: true })
      } else {
        const response = await axios.get(`contpaq/orders-planner`)
        const checkErrors = checkResponse(response)
        if (checkErrors) {
          commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.contpaq', text: 'errors.syncro_request_error', icon: 'alert-circle-outline' }, { root: true })
        } else {
          commit('SET_ACCEPT_ALERT', { color: 'success', title: 'planner.orders_updated', icon: 'checkmark-circle-outline' }, { root: true })
          commit('SET_ORDERS', response.data)
        }
      }
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'alert-circle-outline' }, { root: true })
    }
  }
}

const getters = {
  orders: state => state.orders,
  warehousesOptions: state => state.warehousesOptions
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
